import { Form, Select } from "formik-antd"
import * as React from "react"
import { useIntl } from "react-intl"
import { employmentStatus } from "../../utils/values"

function CreditScoreInput(props) {
  const intl = useIntl()
  const locale = navigator.language

  let option = "defaultOption"
  if (locale === "es") {
    option = "esOption"
  }

  const employmentStatusTitle = intl.formatMessage({
    id: "ApplyPage.personalProfile.employmentStatus",
  })
  const employmentStatusError = intl.formatMessage({
    id: "ApplyPage.personalProfile.employmentStatus.error",
  })

  return (
    <Form.Item
      name={props.name}
      hasFeedback
      required={false}
      label={employmentStatusTitle}
      validate={(value) =>
        value.length === 0 ? employmentStatusError : undefined
      }
    >
      <Select
        name={props.name}
        mode="single"
        size="large"
        style={{ textAlign: "left" }}
        placeholder={employmentStatusTitle}
      >
        {employmentStatus.map((s) => (
          <Select.Option key={s.value}>{s[option]}</Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default CreditScoreInput
